/*=========================================================================================
  File Name: rolesActions.js
  Description: Vuex Store - roles actions
==========================================================================================*/

import axios from 'axios';
import state from '../state';

export default {
    getRoles({commit}) {
        return new Promise((resolve, reject) => {
            axios({url: state.API_URL + '/auth/organization/roles', method: 'GET'})
                .then(({data}) => {
                    commit('SET_PERMISSIONS', data.permissions);
                    resolve(data.roles);
                }).catch(({response}) => {
                reject(response.data);
            });
        })
    },
    viewRole({commit}, id) {
        return new Promise((resolve, reject) => {
            axios({url: state.API_URL + '/auth/organization/roles/view/' + id, method: 'GET'})
                .then(({data}) => {
                    resolve(data);
                }).catch(({response}) => {
                reject(response.data);
            });
        })
    },
    createRole({commit}) {
        return new Promise((resolve, reject) => {
            axios({url: state.API_URL + '/auth/organization/roles/create', method: 'GET'})
                .then(({data}) => {
                    resolve(data);
                }).catch(({response}) => {
                reject(response.data);
            });
        })
    },
    storeRole({commit}, payload) {
        return new Promise((resolve, reject) => {
            axios({url: state.API_URL + '/auth/organization/roles/store', data: payload, method: 'POST'})
                .then(({data}) => {
                    resolve(data);
                }).catch(({response}) => {
                reject(response.data);
            });
        })
    },
    editRole({commit}, id) {
        return new Promise((resolve, reject) => {
            axios({url: state.API_URL + '/auth/organization/roles/edit/' + id, method: 'GET'})
                .then(({data}) => {
                    resolve(data);
                }).catch(({response}) => {
                reject(response.data);
            });
        })
    },
    updateRole({commit}, payload) {
        return new Promise((resolve, reject) => {
            axios({
                url: state.API_URL + '/auth/organization/roles/update/' + payload.id,
                data: payload.data,
                method: 'POST'
            })
                .then(({data}) => {
                    resolve(data);
                }).catch(({response}) => {
                reject(response.data);
            });
        })
    },
    deleteRole({commit}, id) {
        return new Promise((resolve, reject) => {
            axios({url: state.API_URL + '/auth/organization/roles/delete/' + id, method: 'DELETE'})
                .then(({data}) => {
                    resolve(data);
                }).catch(({response}) => {
                reject(response.data);
            });
        })
    },
};
